export default function Footer() {
  return (
    <footer className="bg-dark-950 text-white">
      <div className="mx-auto max-w-7xl px-6 py-16 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-5">
              <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-gradient-to-br from-brand-500 to-teal-500 shrink-0">
                <i className="ri-home-gear-line text-white text-2xl"></i>
              </div>
              <div className="flex flex-col leading-tight">
                <span className="text-xl font-bold tracking-tight text-white">
                  Casa<span className="text-brand-400">ReNova</span><span className="text-teal-400">Plus</span>
                </span>
                <span className="text-[10px] text-gray-500 tracking-widest uppercase">Neuenegg · Suisse</span>
              </div>
            </div>
            <div className="flex gap-3">
              <a href="tel:+41764803188" className="w-9 h-9 flex items-center justify-center bg-white/5 hover:bg-brand-500 rounded-lg transition-colors cursor-pointer" title="Filipe Oliveira">
                <i className="ri-phone-line text-sm text-gray-300"></i>
              </a>
              <a href="mailto:info@casarenovaplus.ch" className="w-9 h-9 flex items-center justify-center bg-white/5 hover:bg-brand-500 rounded-lg transition-colors cursor-pointer">
                <i className="ri-mail-line text-sm text-gray-300"></i>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-bold text-base mb-5 text-white">Nos Services</h4>
            <ul className="space-y-2.5 text-gray-400 text-sm">
              <li><a href="/electricite" className="hover:text-brand-400 transition-colors cursor-pointer flex items-center gap-2"><i className="ri-arrow-right-s-line text-brand-500"></i>Installations Électriques</a></li>
              <li><a href="/pompes-chaleur" className="hover:text-brand-400 transition-colors cursor-pointer flex items-center gap-2"><i className="ri-arrow-right-s-line text-brand-500"></i>Pompes à Chaleur</a></li>
              <li><a href="/sanitaire" className="hover:text-brand-400 transition-colors cursor-pointer flex items-center gap-2"><i className="ri-arrow-right-s-line text-brand-500"></i>Plomberie & Sanitaire</a></li>
              <li><a href="/ventilation" className="hover:text-brand-400 transition-colors cursor-pointer flex items-center gap-2"><i className="ri-arrow-right-s-line text-brand-500"></i>Ventilation & Climatisation</a></li>
              <li><a href="/domotique" className="hover:text-brand-400 transition-colors cursor-pointer flex items-center gap-2"><i className="ri-arrow-right-s-line text-brand-500"></i>Domotique</a></li>
              <li><a href="/maintenance" className="hover:text-brand-400 transition-colors cursor-pointer flex items-center gap-2"><i className="ri-arrow-right-s-line text-brand-500"></i>Maintenance 24/7</a></li>
              <li><a href="/renovation" className="hover:text-brand-400 transition-colors cursor-pointer flex items-center gap-2"><i className="ri-arrow-right-s-line text-brand-500"></i>Travaux de Rénovation</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-bold text-base mb-5 text-white">Contact</h4>
            <ul className="space-y-4 text-gray-400 text-sm">
              <li className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center bg-brand-500/20 rounded-lg mt-0.5 shrink-0">
                  <i className="ri-phone-line text-brand-400 text-sm"></i>
                </div>
                <div>
                  <p className="text-white font-medium">Téléphone</p>
                  <p className="text-gray-500 text-xs mb-0.5">Filipe Oliveira</p>
                  <a href="tel:+41764803188" className="hover:text-brand-400 transition-colors block">+41 76 480 31 88</a>
                  <p className="text-gray-500 text-xs mt-1.5 mb-0.5">Francisco Andrade</p>
                  <a href="tel:+41765654203" className="hover:text-brand-400 transition-colors block">+41 76 565 42 03</a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center bg-brand-500/20 rounded-lg mt-0.5 shrink-0">
                  <i className="ri-mail-line text-brand-400 text-sm"></i>
                </div>
                <div>
                  <p className="text-white font-medium">Email</p>
                  <a href="mailto:info@casarenovaplus.ch" className="hover:text-brand-400 transition-colors">info@casarenovaplus.ch</a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center bg-brand-500/20 rounded-lg mt-0.5 shrink-0">
                  <i className="ri-map-pin-line text-brand-400 text-sm"></i>
                </div>
                <div>
                  <p className="text-white font-medium">Adresse</p>
                  <p>Austrasse 95<br />3176 Neuenegg, Suisse</p>
                </div>
              </li>
            </ul>
          </div>

          {/* Zone + horaires */}
          <div>
            <h4 className="font-bold text-base mb-5 text-white">Zone d'Intervention</h4>
            <p className="text-gray-400 mb-3 leading-relaxed text-sm">
              Interventions rapides dans tout le canton de Fribourg et toute la Suisse romande. Service d'urgence disponible 24h/24.
            </p>
            <div className="flex flex-wrap gap-1.5 mb-4">
              {['Neuenegg','Fribourg','Berne','Vaud','Valais','Neuchâtel','Jura'].map((v) => (
                <span key={v} className="text-xs bg-white/5 border border-white/10 text-gray-400 px-2 py-0.5 rounded-full">{v}</span>
              ))}
            </div>
            <a href="/zones-intervention" className="inline-flex items-center gap-1.5 text-brand-400 hover:text-brand-300 text-sm font-medium transition-colors cursor-pointer">
              <i className="ri-map-pin-line text-sm"></i>
              Voir toutes nos zones
            </a>
            <div className="bg-white/5 border border-white/10 rounded-xl p-4">
              <div className="flex items-center gap-2 mb-3">
                <i className="ri-time-line text-brand-400"></i>
                <p className="text-sm font-semibold text-white">Horaires</p>
              </div>
              <p className="text-sm text-gray-400">Lun–Ven : 8h00 – 18h00</p>
              <p className="text-sm text-gray-400">Urgences : <span className="text-brand-400 font-semibold">24/7</span></p>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-8 border-t border-white/10">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-gray-500 text-sm">&copy; 2025 CasaReNovaPlus. Tous droits réservés.</p>
            <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-500">
              <a href="/mentions-legales" className="hover:text-brand-400 transition-colors cursor-pointer">Mentions légales</a>
              <a href="/cgv" className="hover:text-brand-400 transition-colors cursor-pointer">CGV</a>
              <a href="/faq" className="hover:text-brand-400 transition-colors cursor-pointer">FAQ</a>
              <a href="/temoignages" className="hover:text-brand-400 transition-colors cursor-pointer">Témoignages</a>
              <a href="/recrutement" className="hover:text-brand-400 transition-colors cursor-pointer">Recrutement</a>
              <a href="/presentation" className="hover:text-brand-400 transition-colors cursor-pointer">Présentation</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
